import { defineMessages } from "react-intl";

const baseId = "t.components.modals.responseModal.";

export default defineMessages({
  pendingTitle: {
    id: baseId + "pendingTitle",
    defaultMessage: "Pending...",
  },
  errorTitle: {
    id: baseId + "errorTitle",
    defaultMessage: "Error",
  },
  successTitle: {
    id: baseId + "successTitle",
    defaultMessage: "Operation completed",
  },
  errorBodyContent: {
    id: baseId + "errorBodyContent",
    defaultMessage: "An error occurred. Please try again or open a ticket",
  },
  pendingBodyContent: {
    id: baseId + "pendingBodyContent",
    defaultMessage: "Waiting",
  },
  warningBodyContent: {
    id: baseId + "warningBodyContent",
    defaultMessage: "The operation success but there are errors.",
  },
  successBodyContent: {
    id: baseId + "successBodyContent",
    defaultMessage: "Operation success",
  },
  successForwardBodyContent: {
    id: baseId + "successForwardBodyContent",
    defaultMessage: "The operation is successfully forward to the system.",
  },
  close: {
    id: baseId + "close",
    defaultMessage: "Close",
  },
});
